"use strict";

define('controller/task/list',['require','exports','module','underscore','../base','../../view/page.list','../../config','../../model/user','../../model/task','../../model/sort','../../libs/format/link','../../libs/format/date','../../libs/format/bold','langs','../../view/empty.table'],function (require, exports, module) {
  var _ = require('underscore'),
    RegionController = require('../base'),
    PageListView = require('../../view/page.list'),
    config = require('../../config'),
    User = require('../../model/user'),
    Task = require('../../model/task'),
    Sort = require('../../model/sort'),
    linkFormatter = require('../../libs/format/link'),
    dateFormatter = require('../../libs/format/date'),
    boldFormatter = require('../../libs/format/bold'),
    langs = require('langs'),
    EmptyTableView = require('../../view/empty.table');
  var p = langs.phrase;
  var TASK_FIELDS = [{
    displayName: 'Study Title',
    name: 'studyTitle',
    autoComplete: {
      entity: 'study',
      field: 'title'
    },
    sortName: 'title'
  }, {
    displayName: p('TasksPage.VSFields.StudyLabel'),
    name: 'studyLabel',
    autoComplete: {
      entity: 'study',
      field: 'label'
    },
    sortName: 'label'
  }, {
    displayName: p('TasksPage.VSFields.TaskDisplayName'),
    name: 'taskDisplayName',
    autoComplete: {
      entity: 'task',
      field: 'displayName'
    },
    sortName: 'displayName'
  }, {
    displayName: 'Submission Type',
    name: 'templateType',
    autoComplete: {
      entity: 'template',
      field: 'type'
    }
  }, {
    displayName: 'My Assignment',
    name: 'assignment',
    autoComplete: {
      entity: 'assignment',
      field: 'displayName'
    },
    sortName: 'displayName'
  }, {
    displayName: p('TasksPage.VSFields.All'),
    name: 'q'
  }];
  var TASK_COLUMNS = [{
    data: 'studyLabel',
    text: p('TasksPage.Columns.StudyLabel'),
    formatter: linkFormatter('submission:detail', {
      studyId: 'studyId',
      documentId: 'documentId'
    }),
    sortable: false,
    nowrap: true
  }, {
    data: 'taskDisplayName',
    text: 'Task',
    formatter: boldFormatter,
    sortable: false
  }, {
    data: 'studyTitle',
    text: 'Study Title',
    sortable: false,
    maxWidth: '20em'
  }, {
    data: 'templateType',
    text: 'Submission Type',
    sortable: false
  }, {
    data: 'assignment',
    text: p('TasksPage.Columns.Assignment'),
    sortable: false
  }, {
    data: 'taskBeginDate',
    text: p('TasksPage.Columns.TaskBeginDate'),
    sortable: true,
    formatter: dateFormatter(),
    collapsing: true,
    type: 'date'
  }];
  var DEFAULT_SORT = {
    sort: 'taskBeginDate',
    sortDirection: Sort.DESCENDING
  };
  var TaskListController = RegionController.extend({
    header: p('App.Title'),
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      app.execute('achievement:unlock', 'Task master');
      var root = new PageListView({
          sectionTitle: p('TasksPage.Title')
        }),
        tasks = Task.all(),
        table = root.table;
      table.tabletStackable = true;
      table.compact = false;
      table.padded = true;
      root.$el.css(config.contentCss);
      root.setupCollection(tasks, {
        autoFetch: true
      }).setupSortDefaults(DEFAULT_SORT).setupLoading().setupEmptyView(EmptyTableView.Row, {
        text: p('TasksPage.NoTasks'),
        headerTag: 'h4',
        icon: 'check'
      }).setupVisualSearch(TASK_FIELDS, state).setupRowLink('submission:detail', {
        studyId: 'studyId',
        documentId: 'documentId'
      }).setupPaginate().setupPageSizes().setupTableSort().setupColumns(TASK_COLUMNS);
      function applyAuthority() {
        if (app.role.get('description') === User.IRB_ADMIN) {
          root.spfHelper.filter.unset('role');
        } else {
          root.spfHelper.filter.set('role', app.role.get('description'));
        }
      }
      root.listenTo(app.role, 'change:description', applyAuthority).listenTo(tasks, 'sync', function () {
        region.show(root);
      });
      state.addPageDependencies([tasks]);
      if (app.role.has('description')) {
        applyAuthority();
        tasks.fetch();
      } else {
        app.role.once('change:description', function () {
          tasks.fetch();
        });
      }
    }
  });
  module.exports = TaskListController;
});

